import { render, staticRenderFns } from "./SaleCollectQuery.vue?vue&type=template&id=77faea69&scoped=true"
import script from "./SaleCollectQuery.vue?vue&type=script&lang=js"
export * from "./SaleCollectQuery.vue?vue&type=script&lang=js"
import style0 from "./SaleCollectQuery.vue?vue&type=style&index=0&id=77faea69&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77faea69",
  null
  
)

export default component.exports